import React from 'react';
import { useParams } from 'react-router-dom';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import ContactListFormDisplay from '../components/ContactListFormDisplay';
import Header from '../components/Header';
import Footer from '../components/Footer';
import MobileBottomNav from '@/components/MobileBottomNav';
import { bodyMuted, displayTitle, glow, pageBg } from '@/components/ui/design';

export default function ContactFormScreen() {
    const { listId } = useParams<{ listId: string }>();

    if (!listId) {
        return (
            <div className={`relative isolate min-h-screen overflow-hidden flex items-center justify-center px-4 ${pageBg}`}>
                <div className={glow} />
                <div className="text-center">
                    <h1 className={`${displayTitle} mb-6`}>Invalid Form Link</h1>
                    <p className={bodyMuted}>The form link you're trying to access is invalid.</p>
                </div>
            </div>
        );
    }

    return (
        <HelmetProvider>
            <div className={`min-h-screen ${pageBg}`}>
                <Helmet>
                    <title>Contact Form - EventUp</title>
                    <meta name="description" content="Fill out this contact form to join our mailing list." />
                    <meta name="robots" content="noindex, nofollow" />
                </Helmet>
                
                <Header />
                
                <main className="py-8 sm:py-12">
                    <ContactListFormDisplay listId={listId} />
                </main>
                
                <Footer hasMobileNav />
                <MobileBottomNav />
            </div>
        </HelmetProvider>
    );
}
